import React, { useEffect } from 'react';

import Col from 'react-bootstrap/Col';
import DateDesignerLeadFilter from './DateDesignerLeadFilter';
import ListView from '../shared/lists/ListView';
import MiscSaleReportItem from './MiscSaleReportItem';
import PagedListControl from '../shared/lists/PagedListControl';
import Row from 'react-bootstrap/Row';
import SortableTh from '../shared/table/SortableTh';
import CustomTh from '../shared/table/CustomTh';
import ExportButton from '../shared/buttons/ExportButton';

const MiscSaleReport = ({
    items,
    filter,
    pageInfo,
    setFilter,
    setUrl
}) => {
    const postUrl = `/api/reports/miscsalereport`;

    useEffect(() => setUrl(postUrl), []);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="Entered"
                    sort={pageInfo}
                    sortName="DateEntered"
                    width={85}
                />
                <SortableTh
                    content="Customer"
                    sort={pageInfo}
                    sortName="CustomerName"
                />
                <SortableTh
                    content="Designer"
                    sort={pageInfo}
                    sortName="Designer"
                    width={80}
                />
                <SortableTh
                    content="Total"
                    sort={pageInfo}
                    sortName="Total"
                    width={80}
                />
                <SortableTh
                    content="Deposit"
                    sort={pageInfo}
                    sortName="Deposit"
                    width={80}
                />
                <SortableTh
                    content="Deposit Type"
                    sort={pageInfo}
                    sortName="PaymentType"
                    width={105}
                />
                <SortableTh
                    content="Deposit Date"
                    sort={pageInfo}
                    sortName="DateDeposit"
                    width={85}
                />
                <SortableTh
                    content="Balance"
                    sort={pageInfo}
                    sortName="BalanceDue"
                    width={80}
                />
                <SortableTh
                    content="Paid"
                    sort={pageInfo}
                    sortName="PaidInFull"
                    width={55}
                />
                <SortableTh
                    content="Date Paid"
                    sort={pageInfo}
                    sortName="DateBalancePaid"
                    width={85}
                />
                <CustomTh
                    content="Description"
                />
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/miscsalereport"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items.map((item, index) =>
        <MiscSaleReportItem
            item={item}
            totalRow={item.designer === "TOTAL"}
            key={item.id}
        />
    );

    return (
        <Row>
            <Col>
                <DateDesignerLeadFilter
                    filter={filter}
                    setFilter={setFilter}
                    hideLeadFilter={true}
                />
                <Row className='pb-5 mt-3'>
                    <Col className="small">
                        <ListView
                            animate={false}
                            canAdd={false}
                            items={listItems}
                            tableHead={tableHead}
                        />
                        <PagedListControl
                            {...pageInfo}
                        />
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default MiscSaleReport;